import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#6b7280","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_4 = {
  key: 2,
  class: "log-scroll"
}
const _hoisted_5 = { class: "admin-table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  style: {"color":"#9ca3af","font-size":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "data-title" }, "Chamados de Suporte", -1)),
    ($setup.supportLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : ($setup.supportTickets.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nenhum chamado de suporte."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Data"),
                  _createElementVNode("th", null, "Título"),
                  _createElementVNode("th", null, "Solicitante"),
                  _createElementVNode("th", null, "Status"),
                  _createElementVNode("th", null, "Ação")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.supportTickets, (st) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: st.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString($setup.formatDate(st.createdAt)), 1),
                    _createElementVNode("td", null, _toDisplayString(st.title), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("code", null, _toDisplayString(st.requestedByUsername), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(st.status === 'resolvido' ? 'badge-ok' : 'badge-pending')
                      }, _toDisplayString(st.status), 3)
                    ]),
                    _createElementVNode("td", null, [
                      (st.status !== 'resolvido')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-table-action",
                            onClick: ($event: any) => ($setup.resolveSupportTicket(st.id))
                          }, "Resolver", 8, _hoisted_6))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.formatDate(st.resolvedAt)), 1))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
  ]))
}